const Slugify = {
  install(Vue2) {
    Vue2.prototype.$slugify = {
      transform(text) {
        return text.toString().toLowerCase()
          .replace(/(\w)\'/g, '$1')
          .replace(/[^a-z0-9_\-]+/g, '-')
          .replace(/\-\-+/g, '-')
          .trim()
      },
    }
  },
}

export default Slugify
